import UpdateFilterUrl from "./updatefilterurl.js";
import FilterValues from "./filtervalues.js";
import FilterUIHelpers from "./filteruihelpers.js";
import SelectedFilters from "./selectedfilters.js";
import { prodListValues } from './shared.js';

const colorFilter = document.getElementById('colorFilter');
const mobileFilterDropDown = document.getElementById('filterDropDown');

class ColorSelectorFilter {
    constructor() {
        this.action = this.action.bind(this);
        this.keyAction = this.keyAction.bind(this);
    }

    /**
     * Handles the action when a color filter is clicked.
     * @param {Event} e The event object.
     * @return {void}
     */
    action(e) {
        e.preventDefault();

        let element = e.currentTarget;

        if (element.getAttribute('aria-selected') !== 'true') {
            this.add(element, true);
        } else {
            this.remove(element);
        }

        if (mobileFilterDropDown.classList.contains('active')) {
            mobileFilterDropDown.click();
        }

        UpdateFilterUrl.update(FilterValues, prodListValues, false);
    };

    /**
     * Handles the key action when a key is pressed on a color filter.
     * @param {KeyboardEvent} e The keyboard event object.
     * @return {void}
     */
    keyAction(e) {
        if (e.key === 'Enter') {
            this.action(e);
        }
    };

    /**
     * Updates the color filter element.
     * @param {HTMLElement} element The color filter element.
     * @return {void}
     */
    update(element) {
        this.add(element, false);
    };

    /**
     * Updates the counts for each color filter option.
     * @param {Array<Object>} filterOptions The array of filter options with their counts.
     * @return {void}
     */
    updateCounts(filterOptions) {
        if (document.getElementById('colorFilter')) {
            const filters = colorFilter.getElementsByClassName('filterColorBlock');
            let filterId, optionCnt;

            for (let i = 0; i < filters.length; i++) {
                filterId = FilterValues.getFilterId(filters[i].id);
                optionCnt = 0;

                if (filterId && filterOptions) {
                    for (let j = 0; j < filterOptions.length; j++) {
                        if (filterOptions[j].Id === filterId) {
                            optionCnt = filterOptions[j].Count;
                            break;
                        }
                    }
                }

                FilterUIHelpers.getUpdatedFilterCount(document.getElementById(filters[i].id + '_label'), optionCnt);
                filters[i].title = filters[i].getAttribute('data-filter') + ' (' + optionCnt + ')';
            }
        }
    };

    /**
     * Adds a color filter.
     * @param {HTMLElement} element The color filter element.
     * @param {boolean} logFilter Whether to log the filter action.
     * @return {void}
     */
    add(element, logFilter) {
        element.setAttribute('aria-selected', 'true');
        element.querySelector('.svgWrapper').classList.remove('hide');
        element.querySelector('.svgWrapper').classList.add('show');
        FilterValues.addFilter(element.id, logFilter);
        SelectedFilters.addToSelectedFilter(element);
    };

    /**
     * Removes a color filter.
     * @param {HTMLElement} element The color filter element.
     * @return {void}
     */
    remove(element) {
        element.setAttribute('aria-selected', 'false');
        element.querySelector('.svgWrapper').classList.remove('show');
        element.querySelector('.svgWrapper').classList.add('hide');
        FilterValues.removeFilter(element.id);
        SelectedFilters.removeFromSelectedFilter(element);
    };

    /**
     * Clears all color filters in the provided list.
     * @param {Array<string>} list The list of color filterIds to clear.
     * @return {void}
     */
    clear(list) {
        for (let i = 0; i < list.length; i++) {
            this.remove(document.getElementById(list[i]));
        }
    };

    /**
     * Initializes event listeners for color filter elements.
     * @return {void}
     */
    events() {
        if (colorFilter) {
            colorFilter.querySelectorAll('button.filterColorBlock').forEach((element) => {
                element.removeEventListener('click', this.action);
                element.addEventListener('click', this.action);
                element.removeEventListener('keydown', this.keyAction);
                element.addEventListener('keydown', this.keyAction);
            });
        }
    };
}

export default new ColorSelectorFilter();